var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{attrs:{"dark":"","padless":""}},[_c('v-card',{staticClass:"navy",attrs:{"flat":"","width":"100%"}},[_c('v-container',{staticClass:"py-1"},[_c('Ending'),_c('v-divider',{staticClass:"my-1"}),_c('LangSocial')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }